import React from 'react';
import { InfoTable } from 'components/InfoTable';
import { CountryType } from 'components/registry/components/CountryType/CountryType';
import { ProducerListDto } from 'modules/feed/feedRegistry/api/params';
import { CerberusIntegrationStatus } from 'components/CerberusIntegrationStatus';
import { CerberusIntegrationError } from 'components/CerberusIntegrationError';
import { ProductType } from '../../../../../../../../types/types';
import { LocationsList } from './components';
import { formatProducer } from '../../../../../../../../../utils';

type ProducersListProps = {
  producers: ProductType['producerList'];
};

export const ProducersList = ({ producers }: ProducersListProps) => (
  <>
    {producers.map((producer) => (
      <InfoTable
        key={producer.id}
        itemList={[{ item: { ...producer } }]}
        rows={[
          {
            dataFormatter: (data) => (
              <>
                <CountryType isResident={data.resident} />
                <span style={{ marginLeft: '8px' }}>
                  {formatProducer(data as ProducerListDto, true)}
                </span>
                <CerberusIntegrationStatus
                  isEnteredManually={producer.enteredManually}
                  isNotLinkedWithCerberus={producer.notLinkedWithCerberus}
                />
                <CerberusIntegrationError showMessage={producer.incorrectCerberusLink} />
              </>
            ),
            header: {
              key: 'producer',
              title: 'Производитель',
            },
          },
          {
            dataFormatter: (data) => <LocationsList locations={data.locationList} />,
            header: {
              key: 'locationList',
              title: 'Площадки',
            },
          },
        ]}
      />
    ))}
  </>
);
